import SDIcon from './SDIcon'

const IconCarbonAirlinePassengerCare = (props) => (
  <SDIcon title='Passenger Care' {...props}>
    <path
    d='M18,23H16V21a3.0033,3.0033,0,0,0-3-3H9a3.0033,3.0033,0,0,0-3,3v2H4V21a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z'
    transform='translate(0 0)'
    />
    <path d='M11,6A3,3,0,1,1,8,9a3,3,0,0,1,3-3m0-2a5,5,0,1,0,5,5A5,5,0,0,0,11,4Z' transform='translate(0 0)' />
    <rect x='2' y='26' width='28' height='2' />
    <path
    d='M27.303,8a2.6616,2.6616,0,0,0-1.9079.8058L25,9.2112l-.3951-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25,17l4.2108-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,8Z'
    transform='translate(0 0)'
    />
  </SDIcon>
)

export default IconCarbonAirlinePassengerCare
